/**
 * React Query Hook for fetching tutors list
 */

import { useQuery } from '@tanstack/react-query';
import { getTutors } from '@/api/services/tutorsApi';
import type { GetTutorsParams } from '@/types/api';
import { useAuthContext } from '@/contexts';
import { getViewerIdentity, tutorQueryKeys } from './queryKeys';

/**
 * Query hook for fetching tutors with filters and pagination
 * Uses TanStack Query with caching strategy
 * Cache key: ['tutors', params]
 */
export const useTutors = (params?: GetTutorsParams) => {
  const { firebaseUser, profile } = useAuthContext();
  const viewerIdentity = getViewerIdentity(firebaseUser, profile);

  return useQuery({
    queryKey: tutorQueryKeys.list(viewerIdentity, params),
    queryFn: async ({ signal }) => {
      return getTutors(params, signal);
    },
    retry: 1,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
  });
};
